"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var ProductCategoriesModel = /** @class */ (function () {
    function ProductCategoriesModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/crm/product-categories",
            UPDATE: APPURL + "/api/v1/crm/product-categories",
            CREATE: APPURL + "/api/v1/crm/product-categories",
        };
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    ProductCategoriesModel.prototype.extract = function (result) {
        return result.data;
    };
    ProductCategoriesModel.prototype.cacheResults = function (result) {
        return this.extract(result);
    };
    ProductCategoriesModel.prototype.show = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    ProductCategoriesModel.prototype.get = function (data) {
        if (data === void 0) { data = null; }
        var url = this.URLS.FETCH;
        if (data !== null) {
            url = this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data);
        }
        return this.$http
            .get(url)
            .then(this.cacheResults);
    };
    ProductCategoriesModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    ProductCategoriesModel.prototype.toggleData = function (product) {
        return this.$http
            .patch(this.URLS.FETCH + "/toggle/" + product.id, product)
            .then(this.cacheResults);
    };
    ProductCategoriesModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    ProductCategoriesModel.prototype.delete = function (data) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + data.id)
            .then(this.cacheResults);
    };
    ProductCategoriesModel.prototype.search = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/search", params)
            .then(this.cacheResults);
    };
    return ProductCategoriesModel;
}());
ProductCategoriesModel.$inject = ["$http", "APPURL"];
exports.default = ProductCategoriesModel;
